interface BaseOffRentOrderDetails {
  equipmentName: string;
  equipmentId: string;
  pickupDate: string | null;
  rentalId: string;
  notes?: string;
}

export interface ScheduleOffRentOrderDetails extends BaseOffRentOrderDetails {}

export interface CancelOffRentOrderDetails {
  rentalId: string;
}

export enum OffRentOrderUpdateFormFieldType {
  EQUIPMENT_DETAIL = 'EQUIPMENT_DETAIL',
  PICKUP_DATE = 'PICKUP DATE',
  NOTES = 'NOTES',
}

export type OffRentOrderUpdateFormFieldKey = 'equipmentDetail' | 'pickupDate' | 'notes';

export interface OffRentOrderData {
  rental_id: string;
  off_rent_date_requested: string | null;
}

export interface OffRentOrderDataUpdateNotes {
  id: number;
  content: string;
  rental_note_type_id: number;
}

export interface RentalNoteTypeResponse {
  rental_note_type_id: number;
  name: string;
}

export interface RentalNoteResponse {
  rental_note_id: number;
  rental_note_type_id: number;
  content: string;
  rental_id: number;
  created_by_user_id: number;
  date_created: string;
  rental_note_type: RentalNoteTypeResponse;
}
